import { nanoid } from 'nanoid';
import type { FormField } from './types';

export interface FormTemplate {
  slug: string;
  name: string;
  description: string;
  fields: () => FormField[];
}

export const MANUFACTURING_TEMPLATE: FormTemplate = {
  slug: 'manufacturing',
  name: 'Manufacturing Intake',
  description: 'Standard intake for manufacturing facility projects.',
  fields: () => [
    {
      id: nanoid(),
      type: 'text',
      label: 'Project Name',
      required: true,
      placeholder: 'e.g. Advanced Widget Manufacturing Facility',
    },
    {
      id: nanoid(),
      type: 'number',
      label: 'Capital Investment ($)',
      required: true,
      min: 0,
      helpText: 'Total capital investment in US dollars',
    },
    {
      id: nanoid(),
      type: 'number',
      label: 'Permanent Jobs Created',
      required: true,
      min: 0,
      max: 10000,
    },
    {
      id: nanoid(),
      type: 'select',
      label: 'Facility Type',
      required: true,
      options: [
        'Greenfield (New Build)',
        'Expansion of Existing',
        'Acquisition / Retooling',
        'Warehouse / Distribution',
      ],
    },
    {
      id: nanoid(),
      type: 'text',
      label: 'NAICS Code',
      required: false,
      placeholder: 'e.g. 332710',
      helpText: '6-digit NAICS code for the primary industry',
    },
    {
      id: nanoid(),
      type: 'number',
      label: 'Facility Square Footage',
      required: false,
      min: 0,
    },
    {
      id: nanoid(),
      type: 'number',
      label: 'Construction Timeline (months)',
      required: false,
      min: 1,
      max: 120,
    },
    {
      id: nanoid(),
      type: 'file',
      label: 'Supporting Documents',
      required: false,
      accept: '.pdf,.docx,.xlsx',
      maxSizeMb: 20,
      helpText: 'Site plans, business plans, pro formas (PDF, Word, Excel)',
    },
  ],
};

export const ALL_TEMPLATES: FormTemplate[] = [MANUFACTURING_TEMPLATE];
